export const Marquee = ({ text }) => (
  <div className="relative overflow-hidden border-y border-white/10 bg-white/[0.02] py-4 sm:py-5">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((rep) => (
        <div key={rep} className="flex shrink-0 items-center">
          {Array.from({ length: 6 }).map((_, i) => (
            <span
              key={i}
              className="font-display mx-6 flex items-center gap-6 text-lg font-semibold uppercase tracking-wide text-white/25 sm:text-2xl"
            >
              {text}
              <span className="text-[#0f93cc]">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
